import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@apollo/client";

import { DisLikeIcon, LikeIcon } from "../../../Shared/SVGs/ActionIcons";
import { LIKE_MESSAGE_MUTATION } from "../../../Queries/ask-vyrill";
import { updateSingleMessage } from "../Actions";
import { capitalize } from "../../../utilities";

const QuestionRow = ({ k }) => {
  const askVyrillDuration = useSelector(
    (state) => state.askVyrill.askVyrillDuration
  );
  const custom_start_date = useSelector(
    (state) => state.askVyrill.custom_start_date
  );
  const custom_end_date = useSelector(
    (state) => state.askVyrill.custom_end_date
  );
  const start_date = moment(k?.start_date).format("MMMM D, YYYY");
  const end_date = moment(k?.end_date).format("MMMM D, YYYY");
  const custom_start_date_format =
    moment(custom_start_date).format("MMMM D, YYYY");
  const custom_end_date_format = moment(custom_end_date).format("MMMM D, YYYY");

  const [likeMessage] = useMutation(LIKE_MESSAGE_MUTATION);
  const dispatch = useDispatch();

  const handleLikeClick = async (e) => {
    if (k?._id) {
      try {
        const response = await likeMessage({
          variables: {
            like: e,
            messageId: k?._id,
          },
        });
        dispatch(
          updateSingleMessage({
            id: k._id,
            updatedMessage: response?.data?.likeMessage,
          })
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <div
      style={{
        display: "flex",
        background: "#f3ffff",
        color: "#000",
        padding: "15px 0px",
        marginBottom: "31px",
        minHeight: "71px",
      }}
    >
      <div className="chatgpt-profile">
        <img
          src={require("@src/assets/images/vyrill/chat-user.png").default}
          alt=""
          width="23px"
        />
      </div>
      <div className="chat-question">
        <b>{capitalize(k?.content)}</b>
        <div className="chat-date-range">
          Date range -{" "}
          {k?.duration === "all_dates"
            ? "All dates"
            : k?.duration === "custom"
            ? `${custom_start_date_format} - ${custom_end_date_format}`
            : `${start_date} - ${end_date}`}
        </div>
      </div>
      <div className="d-flex align-items-center">
        <span
          onClick={() => handleLikeClick(k.like == 1 ? 0 : 1)}
          role="button"
        >
          <LikeIcon fill={k.like == 1 ? "#e62580" : "#6B727A"} />
        </span>
        <span
          onClick={() => handleLikeClick(k.like == -1 ? 0 : -1)}
          role="button"
        >
          <DisLikeIcon fill={k.like == -1 ? "#e62580" : "#6B727A"} />
        </span>
      </div>
    </div>
  );
};

export default QuestionRow;
